import useSWR from 'swr'
import {
  getCompensation,
  getPartner,
  getProgramConfig,
  getVolumeSource,
  listApplications,
  listPartnerReferrals,
  listPartners,
  listPayouts,
} from 'submission/lib/partner-api'
import type { ApplicationStatus, PayoutStatus } from 'views/Partners/types'

const opts = { refreshInterval: 30000, revalidateOnFocus: true }

export const usePartners = () =>
  useSWR(['partners'], () => listPartners(), opts)

export const usePartner = (id: number | null) =>
  useSWR(id === null ? null : ['partner', id], () => getPartner(id as number))

export const usePartnerReferrals = (id: number | null) =>
  useSWR(id === null ? null : ['partner-referrals', id], () =>
    listPartnerReferrals(id as number),
  )

export const usePartnerApplications = (status: ApplicationStatus) =>
  useSWR(['partner-applications', status], () => listApplications(status), opts)

export const usePartnerPayouts = (status: PayoutStatus) =>
  useSWR(['partner-payouts', status], () => listPayouts(status), opts)

export const useProgramConfig = () =>
  useSWR(['partner-program-config'], () => getProgramConfig())

export const useDealVolumeSource = (dealId: string | null) =>
  useSWR(dealId ? ['deal-volume-source', dealId] : null, () =>
    getVolumeSource(dealId as string),
  )

export const useDealCompensation = (dealId: string | null) =>
  useSWR(dealId ? ['deal-compensation', dealId] : null, () =>
    getCompensation(dealId as string),
  )
